"use strict";

var _type = require("../_utils/type");
var SelectSizeTypes = (0, _type.tuple)('l', 'default', 's');
var MobileSelectSizeTypes = (0, _type.tuple)('xxl', 'default');
var SelectWidthTypes = (0, _type.tuple)('default', 'full');

/**
 * 原生单选 Props
 */

/**
 * 模拟单选 Props
 */

// export interface SelectSearchProps<T> {}